/**
 * Welfare 页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const welfareCommonConfig = {
  texts: {
    myWallet: 'My Wallet',
    coins: 'coins',
    dailyCheckIn: 'Daily Check-in',
    youHaveCheckedIn: 'You have checked in for',
    dayStraight: 'day straight!',
    checkIn: 'Check in',
    tomorrowToGetMore: 'Tomorrow to Get More',
    tomorrowCheckIn: 'Tomorrow Check in',
    tasks: 'Tasks',
    checkInGet: 'Check in get',
    get: 'get',
    ok: 'Ok',
    go: 'go',
    day: 'Day',
    // WelfareGuideAddScreen 文案
    guideAddStep1: 'Click',
    guideAddStep2: 'share',
    guideAddStep3: 'Add Home To Screen',
    guideAddAtTopRight: 'at top right',
    guideAddAtBottom: 'at bottom',
    guideAddAtBottomRight: 'at bottom right',
    guideAddShare: '"share"',
    guideAddToScreen: '"Add Home To Screen"',
    // WelfareGuideOpen 文案
    guideOpenTitle: 'To enhance your reading experience, you can click the menu button in the upper right corner and select',
    guideOpenAction: '"Open in external browser."',
  },
}
